import basicmodal from './basicmodal';

function setCookie(name, value, days) {
	const d = new Date();
	d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
	document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
}

function getCookie(name) {
	const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
	return v ? v[2] : null;
}

const element = document.getElementById('per-page-modal-content');

// If it isn't "undefined" and it isn't "null", then it exists.
if (typeof (element) !== 'undefined' && element != null) {
	const modals = document.querySelectorAll('[data-pagemodalid]');
	const modalid = modals[0].getAttribute('data-pagemodalid');

	if (!getCookie(modalid)) {
		setCookie(modalid, true, 30);
		basicmodal.launch(document.getElementById(modalid), { className: 'perpage-modal' });
	}
}
